module.exports = __webpack_public_path__ + "img/personal4.b1308c3d.png";